import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MyCheckbox = ({ children, ...props }) => {
  // children2 has on props, but i think is not necessary...
  // React treats radios and checkbox inputs differently other input types, select, and textarea.
  // Formik does this too! When you specify `type` to useField(), it will
  // return the correct bag of props for you -- a `checked` prop will be included
  // in `field` alongside `name`, `value`, `onChange`, and `onBlur`
  const [field] = useField({ ...props, type: 'checkbox' })
  return (
    <div className="flex items-center">
      <div className="flex h-4 items-center">
        <input
          className="h-5 w-5 rounded border-orange-300 text-orange-500 focus:ring-orange-500"
          type="checkbox"
          {...field}
          {...props}
        />
      </div>
      <div className="ml-3 text-sm">
        <label className="font-medium text-slate-900" htmlFor={field.name}>
          {' '}
          {children}
        </label>
      </div>
    </div>
  )
}
export default MyCheckbox

MyCheckbox.propTypes = {
  children: PropTypes.node,
}
